export enum Key {
    ArrowDown = 'ArrowDown',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    ArrowUp = 'ArrowUp',
    Enter = 'Enter',
    Escape = 'Escape',
    Space = ' '
}
